import React from 'react';
import { Fake, Label, Radio, RadioButtonContainer } from './RadioButton.styled';

type RadioButtonProps = {
  labelText?: string | null;
  id: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const RadioButton: React.FC<RadioButtonProps> = ({ labelText, id, ...props }) => {
  return (
    <RadioButtonContainer>
      <Radio {...props} id={id} />
      <Fake />
      {labelText && <Label htmlFor={id}>{labelText}</Label>}
    </RadioButtonContainer>
  );
};

export default RadioButton;
